export default "__VITE_ASSET__44c515cb__"